import 'reflect-metadata';
import { jsonProperty, Serializable } from 'ts-serializable';

export class FileFormatModel extends Serializable {
  @jsonProperty(String, null) fileExt: string = '';
  @jsonProperty(String, null) descr: string | null = null;
  @jsonProperty(Number) maxSizeByte: number = 0;
  @jsonProperty(Boolean) isImage: boolean = false;
}
